import {GameFilterDefinitionBase} from "../game-filter-definition-base";
import {GameInfo} from "../../../games/game-info";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {Check} from "@sparkware/app-utils";

export class LiveGameShowsFilterDefinition extends GameFilterDefinitionBase {
    get id(): string {
        return "live-game-shows";
    }

    get text(): string {
        return this.services.translation.translate('GAME_SHOWS');
    }

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        if(Check.isNullOrUndefined(gameInfo.subGroupName)){
            return ApplyGameFilterResult.ExcludeGame;
        }

        if(gameInfo.subGroupName.toLowerCase().indexOf('shows') !== -1) {
            return ApplyGameFilterResult.IncludeGame;
        }
        return ApplyGameFilterResult.ExcludeGame;
    }

}